export default __webpack_public_path__ + "static/TSD_Bubble-02-e4249e9c990403c8feaa03fdaea71250.png";